import React from 'react';
import { NAVIGATE_MODAL_BACK } from 'store/app/actions';
import { useDispatch } from 'react-redux';
import { LayoutChangeEvent, View } from 'react-native';
import { theme } from 'lib/theme';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { useConfirmUnsaved } from 'hooks/useConfirm';
import { FileSourceType } from 'service/file/types';
import { doAssetSaveFilesToAsset } from 'store/actions';
import { Camera } from './Camera';

const ButtonsHeight = 125;
type File = { name: string; uri: string; width: number; height: number };

export const CameraModal: React.FC<ModalScreenProps<ModalScreens.Camera>> = ({
  route,
}) => {
  const dispatch = useDispatch();
  const confirmUnsaved = useConfirmUnsaved();

  const { assetId, eventKey } = route.params;

  const handleUsePhoto = (draftPhoto: File) => {
    dispatch(NAVIGATE_MODAL_BACK());
    dispatch(
      doAssetSaveFilesToAsset({
        assetId,
        eventKey,
        source: FileSourceType.CAMERA,
        files: [
          {
            name: draftPhoto.name,
            uri: draftPhoto.uri,
            width: draftPhoto.width,
            height: draftPhoto.height,
            size: 0,
            file: undefined,
            typeGroup: 'image',
          },
        ],
      }),
    );
  };

  const handleCancel = (draftPhoto: File | undefined) => {
    if (draftPhoto) {
      confirmUnsaved({
        text: 'This photo has not been saved',
        onDiscardText: 'Discard Photo',
        onSaveText: 'Save Photo',
        onSave: () => handleUsePhoto(draftPhoto),
        onDiscard: () => dispatch(NAVIGATE_MODAL_BACK()),
      });
      return;
    }
    dispatch(NAVIGATE_MODAL_BACK());
  };

  const [canvasWidthHeight, setCanvasWidthHeight] = React.useState({
    width: 0,
    height: 0,
  });

  const handleLayout = async (event: LayoutChangeEvent) => {
    const { width: maxWidth, height: maxHeight } = event.nativeEvent.layout;
    setCanvasWidthHeight({
      width: maxWidth,
      height: maxHeight - ButtonsHeight,
    });
  };

  return (
    <View
      style={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.black,
      }}
      onLayout={handleLayout}
    >
      <Camera
        canvasWidth={canvasWidthHeight.width}
        canvasHeight={canvasWidthHeight.height}
        onUsePhoto={handleUsePhoto}
        onCancel={handleCancel}
      />
    </View>
  );
};
